<template>
  <v-dialog
    v-model="dialog"
    max-width="1200px"
    @click:outside="close"

  >
    <v-card>
      <v-form>
        <v-card-title>
          <span class="headline">Generar Solicitudes de Pago Múltiples</span>
        </v-card-title>

        <v-card-text style="min-height: 600px">
          <v-stepper v-model="currentStep" class="elevation-0">
            <v-stepper-header style="background: #607d8b; color: white">
              <v-stepper-step :complete="currentStep > 1" step="1" editable>
                <span class="text-white">Comprobantes Pendientes</span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="currentStep > 2" step="2" editable>
                <span class="text-white">Solicitudes de Pago</span>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- STEP 1: Comprobantes Pendientes -->
              <v-stepper-content step="1">
                <div class="row justify-content-center mt-4">
                  <div class="col-md-10">
                    <div class="row mb-2 align-end" >
                      <div class="col-md-4">
                        <v-combobox
                          v-model="supplier_selected"
                          :items="suppliers"
                          item-text="name"
                          item-value="id"
                          label="Proveedores"
                          multiple
                          clearable
                          dense
                          class="aligned-filter"
                          hide-details="auto"
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0" x-small class="ma-0">
                              {{ item.name }}
                            </v-chip>
                            <span
                              v-if="index === 1"
                              class="grey--text text-caption ml-1"
                            >
                              (+{{ supplier_selected.length - 1 }})
                            </span>
                          </template>
                        </v-combobox>
                      </div>
                      <div class="col-md-4 align-self-end">
                        <v-select
                          v-model="expiration_status"
                          :items="expirations_status"
                          item-text="name"
                          item-value="id"
                          label="Estado"
                          clearable
                          dense
                          class="aligned-filter"
                          hide-details="auto"
                        ></v-select>
                      </div>
                      <div class="col-md-4 d-flex align-self-end justify-end">
                        <v-btn color="info" @click="filterComprobantes">Buscar</v-btn>
                      </div>
                    </div>

                    <div class="mb-4 d-flex align-center">
                      <v-chip
                        v-if="selectedComprobantes.length > 0"
                        color="primary"
                        outlined
                      >
                        <v-icon left small>mdi-check-circle</v-icon>
                        {{ selectedComprobantes.length }} comprobante(s)
                        seleccionado(s)
                      </v-chip>
                      <v-chip
                        v-if="selectedComprobantes.length > 0"
                        class="ml-2"
                        color="red"
                        outlined
                      >
                        <v-icon left small>mdi-cash-multiple</v-icon>
                        Total a pagar: {{ formatPrice(selectedTotalToPay) }}
                      </v-chip>
                    </div>

                    
                    <div style="border: solid 1px #999">
                      <div class="mx-4"> 
                        
                        <v-text-field
                          v-model="searchComprobantes"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                        ></v-text-field>
                      </div>
                      <v-data-table
                        v-model="selectedComprobantes"
                        :headers="headersComprobantes"
                        :items="comprobantesList"
                        :search="searchComprobantes"
                        show-select
                        item-key="id"
                        :items-per-page="10"
                        :footer-props="{
                          itemsPerPageOptions: [5, 10, 15, 20, -1],
                        }"
                        :loading="loading"
                        loading-text="Cargando..."
                        :single-select="false"
                      >
                        <template v-slot:[`header.data-table-select`]>
                          <v-simple-checkbox
                            :value="allSelectableComprobantesSelected()"
                            :indeterminate="someSelectableComprobantesSelected() && !allSelectableComprobantesSelected()"
                            color="primary"
                            @input="toggleSelectAllComprobantes"
                          />
                        </template>
                        <template v-slot:[`item.cbte_fch`]="{ item }">
                          {{ item.cbte_fch }}
                        </template>
                        <template v-slot:[`item.total_factura`]="{ item }">
                          <span class="font-weight-medium">{{
                            formatPrice(item.total_factura)
                          }}</span>
                        </template>
                        <template v-slot:[`item.saldo_pendiente`]="{ item }">
                          <span
                            class="font-weight-bold"
                            :class="
                              item.saldo_pendiente > 0
                                ? 'red--text'
                                : 'green--text'
                            "
                          >
                            {{ formatPrice(item.saldo_pendiente) }}
                          </span>
                        </template>
                        <template v-slot:[`item.expiration`]="{ item }">
                          <span v-html="getStatus(item.expiration)"></span>
                        </template>
                        <template v-slot:[`item.file_path`]="{ item }">
                          <v-tooltip bottom v-if="item.file_path">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="grey" @click.stop="viewComprobante(item)">
                                mdi-paperclip
                              </v-icon>
                            </template>
                            <span>Ver Adjunto</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </div>
                  </div>
                </div>
              </v-stepper-content>

              <!-- STEP 2: Solicitudes de Pago -->
              <v-stepper-content step="2">
                <div class="row justify-content-center">
                  <div class="col-md-10">
                      <v-chip
                        v-if="paymentOrdersList.length > 0"
                        color="red"
                        outlined
                        class="mb-4"
                      >
                        <v-icon left small>mdi-cash-multiple</v-icon>
                        Total a pagar: {{ formatPrice(step2TotalToPay) }}
                      </v-chip>
                    <div class="mb-4 d-flex align-center" style="gap: 16px">
                      <div style="min-width: 300px">
                        <DatePickerEsp
                          :initToday="false"
                          label="Fecha Estimada de Pago"
                          :date="estimated_payment_date"
                          :isRequired="false"
                          name="estimated_payment_date"
                          @setDate="(date) => { estimated_payment_date = date; }"
                          :isViewModal="false"
                        />
                      </div>
                      <div style="min-width: 260px">
                        <v-combobox
                          v-model="payment_method_selected"
                          :items="paymentMethods"
                          item-text="name"
                          item-value="id"
                          label="Forma de pago"
                          clearable
                          dense
                          hide-details="auto"
                          @change="money_account_selected = null"
                        ></v-combobox>
                      </div>
                      <div style="min-width: 260px">
                        <v-combobox
                          v-model="money_account_selected"
                          :items="moneyAccounts"
                          item-text="name"
                          item-value="id"
                          label="Cuenta"
                          clearable
                          dense
                          hide-details="auto"
                          :disabled="payment_method_selected == null"
                        ></v-combobox>
                      </div>
                    
                    </div>

                <div style="border: solid 1px #999">
                  <v-data-table
                    :headers="headersPaymentOrders"
                    :items="paymentOrdersList"
                    item-key="supplier_id"
                    hide-default-footer
                    :items-per-page="-1"
                    class="elevation-1"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div class="font-weight-bold proveedor-cell">
                            {{ item.supplier_name }}
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-center" style="gap: 8px; flex-wrap: wrap">
                            <v-chip small outlined color="primary">
                              <v-icon left x-small>mdi-file-document-outline</v-icon>
                              {{ item.comprobantes.length }} comprobante(s)
                            </v-chip>
                            <v-chip small outlined color="red">
                              <v-icon left x-small>mdi-cash</v-icon>
                              {{ formatPrice(item.total_saldo) }}
                            </v-chip>
                          </div>
                        </td>
                        <td style="min-width: 260px">
                          <v-combobox
                            v-model="item.supplier_bank"
                            :items="item.supplier_banks"
                            :item-text="(b) => b.bank_name + (b.cbu_alias ? ' — ' + b.cbu_alias : '')"
                            item-value="id"
                            dense
                            hide-details
                            placeholder="Sin banco"
                            clearable
                            :disabled="item.status === 1"
                          />
                        </td>
                        <td style="min-width: 200px">
                          <span v-if="item.loading">Procesando...</span>
                          <span v-else-if="item.status === 0">Pendiente de procesado</span>
                          <span v-else-if="item.status === 1 && item.status_create" class="text-green">Creada</span>
                          <span v-else-if="item.status === 1 && !item.status_create" class="text-red">{{ item.msg }}</span>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
                <div class="pt-0 mt-3">
                  <p style="color: #1976d2; float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Comprobantes pendientes de procesar: {{ getPendienteProcesar() }}</p>
                  <p class="text-green" style="float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Comprobantes procesados validos: {{ getProcesadosValidos() }}</p>
                  <p style="color: red; margin-bottom: 0px; font-size: 16px; margin-bottom: 5px">Comprobantes procesados invalidos: {{ getProcesadosNoValidos() }}</p>
                </div>
                <div class="row mt-1" v-if="loading_create">
                  <div class="col-md-12">
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important">
                      <strong>{{ Math.ceil(percent) }}%</strong>
                    </v-progress-linear>
                  </div>
                </div>

              </div>
            </div>

                

              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-card-actions class="dialog-footer px-4">
          <template v-if="currentStep === 1">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
            <v-btn
              color="green"
              text
              @click="nextStep"
              :disabled="selectedComprobantes.length === 0"
            >
              Siguiente
            </v-btn>
          </template>

          <template v-else>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="previousStep"> Anterior </v-btn>
            <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>

            <v-btn
              color="green"
              text
              @click="generatePaymentOrders"
              :disabled="paymentOrdersList.length === 0 || error_create || loading_create || payment_method_selected == null || money_account_selected == null"
              :loading="loading_create"
            >
              Generar Solicitudes
            </v-btn>
          </template>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { paymentOrderService } from "@/libs/ws/paymentOrderService";
import { suppliersService } from "@/libs/ws/suppliersService";
import sections from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import DatePickerEsp from "@/components/DatePickerEsp.vue";
import paymentMethod from "@/constants/paymentMethod";

export default {
  name: "DialogGenerarPaymentOrderMasivo",
  components: {
    DatePickerEsp,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.close();
      }
    });
  },
  data() {
    return {
      currentStep: 1,
      loading: false,
      error_create: false,

      // Step 1: Comprobantes
      searchComprobantes: "",
      selectedComprobantes: [],
      comprobantesList: [],
      headersComprobantes: [
        { text: "Fecha", value: "cbte_fch", sortable: true, align: "left" },
        {
          text: "Proveedor",
          value: "receiver_name",
          sortable: true,
          align: "left",
        },
        {
          text: "Nº Comprobante",
          value: "voucher_number_label",
          sortable: true,
          align: "left",
        },
        {
          text: "Total",
          value: "total_factura",
          sortable: true,
          align: "right",
        },
        {
          text: "Saldo Pendiente",
          value: "saldo_pendiente",
          sortable: true,
          align: "right",
        },
        {
          text: "Estado",
          value: "expiration",
          sortable: false,
          align: "left",
        },
        {
          text: "Adjunto",
          value: "file_path",
          sortable: false,
          filterable: false,
          align: "center",
        },
      ],

      // Step 2: Solicitudes de Pago
      paymentOrdersList: [],
      estimated_payment_date: new Date().toISOString().slice(0, 10),
      headersPaymentOrders: [
        {
          text: "Proveedor",
          value: "supplier_name",
          sortable: true,
          align: "left",
        },
    
        {
          text: "Comprobantes",
          value: "comprobantes",
          sortable: false,
          align: "left",
        },
        {
          text: "CBU/Alias",
          value: "supplier_bank",
          sortable: false,
          align: "left",
          width: "260px",
        },
        {
          text: "Respuesta",
          value: "actions",
          sortable: false,
          align: "right",
          width: "80px",
        },
      ],
      loading_create: false,
      envios_creados: 0,
      envios_no_validos: 0,

      suppliers: [],
      supplier_selected: [],
      expiration_status: null,
      payment_method_selected: null,
      money_account_selected: null,
      paymentMethods: [],
      moneyAccounts: [],
      expirations_status: [
        { id: "vencidas", name: "Vencidas" },
        { id: "no_vencidas", name: "No Vencidas" },
      ],

      expandedOrders: [],
    };
  },
  computed: {
    selectedTotalToPay() {
      return this.selectedComprobantes.reduce(
        (acc, item) => acc + parseFloat(item.saldo_pendiente || 0),
        0,
      );
    },
    step2TotalToPay() {
      return this.paymentOrdersList.reduce(
        (acc, item) => acc + parseFloat(item.total_saldo || 0),
        0,
      );
    },
    percent: {
      get() {
        if (this.paymentOrdersList.length === 0) return 0;
        return (
          (this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100
        ) / this.paymentOrdersList.length;
      },
      set(value) {
        return value;
      },
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.resetDialog();
        this.loadSuppliers();
        this.loadPaymentMethods();
        this.loadMoneyAccounts();
        this.loadComprobantesPendientes();
      }
    },
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    formatPrice(value) {
      return formatUtils.formatPrice(value);
    },

    getStatus(expiration) {
      if (expiration > 0) {
        return '<span class="por_vencer">Vence en ' + expiration + " dias</span>";
      } else if (expiration == 0) {
        return '<span class="vence_hoy">Vence hoy</span>';
      } else if (expiration < 0) {
        return '<span class="vencida">Vencida hace ' + expiration * -1 + " dias</span>";
      } else if (expiration == "PEN") {
        return '<span class="vencida">Pendiente de asociar</span>';
      } else {
        return "";
      }
    },

    viewComprobante(item) {
      window.open(item.file_path, "_blank");
    },

    getPendienteProcesar() {
      if (this.paymentOrdersList.length === 0) return 0;
      return this.paymentOrdersList.filter((element) => element.status === 0).length;
    },

    getProcesadosValidos() {
      if (this.paymentOrdersList.length === 0) return 0;
      return this.paymentOrdersList.filter((element) => element.status === 1 && element.status_create).length;
    },

    getProcesadosNoValidos() {
      if (this.paymentOrdersList.length === 0) return 0;
      return this.paymentOrdersList.filter((element) => element.status === 1 && !element.status_create).length;
    },

    selectableComprobantes() {
      return this.comprobantesList;
    },

    allSelectableComprobantesSelected() {
      const selectableIds = this.selectableComprobantes().map((item) => item.id);
      if (selectableIds.length === 0) return false;

      const selectedIds = this.selectedComprobantes.map((item) => item.id);
      return selectableIds.every((id) => selectedIds.includes(id));
    },

    someSelectableComprobantesSelected() {
      const selectableIds = this.selectableComprobantes().map((item) => item.id);
      if (selectableIds.length === 0) return false;

      const selectedIds = this.selectedComprobantes.map((item) => item.id);
      return selectableIds.some((id) => selectedIds.includes(id));
    },

    toggleSelectAllComprobantes(value) {
      if (value) {
        this.selectedComprobantes = [...this.selectableComprobantes()];
        return;
      }

      this.selectedComprobantes = [];
    },

    async generatePaymentOrders() {
      this.envios_creados = 0;
      this.envios_no_validos = 0;
      this.loading_create = true;

      for (let index = 0; index < this.paymentOrdersList.length; index++) {
        console.log("Procesando orden de pago:", this.paymentOrdersList[index]);
        if (
          this.paymentOrdersList[index].msg === "" &&
          !this.paymentOrdersList[index].status_create &&
          this.paymentOrdersList[index].status === 0
        ) {
          this.paymentOrdersList[index].loading = true;

          const result = await this.createItem(this.paymentOrdersList[index]);

          this.paymentOrdersList[index].loading = false;
          this.paymentOrdersList[index].status = 1;
          this.paymentOrdersList[index].status_create = result.status;
          this.paymentOrdersList[index].msg = result.status ? "" : (result.msg || "Error al crear la solicitud");

          if (result.status) {
            this.envios_creados++;
          }
        }
      }

      this.loading_create = false;

      const total = this.paymentOrdersList.length;
      const errores = total - this.envios_creados;
      console.log("errores", errores);
      if (errores === 0) {
        this.$toast.success(
          "Se crearon " + this.envios_creados + " solicitud(es) de pago correctamente.",
          "Ok"
        );
        this.$emit("loadList");
        this.closeDialog();
      } else {
        this.$toast.warning(
          "Se crearon " + this.envios_creados + " solicitud(es) de pago, pero " + errores + " no se pudieron crear.",
          "Precaución"
        );
        this.error_create = true;
        this.$emit("loadList");
      }

      
    },

    resetDialog() {
      this.currentStep = 1;
      this.selectedComprobantes = [];
      this.comprobantesList = [];
      this.paymentOrdersList = [];
      this.expandedOrders = [];
      this.searchComprobantes = "";
      this.loading = false;
      this.loading_create = false;
      this.envios_creados = 0;
      this.envios_no_validos = 0;
      this.supplier_selected = [];
      this.expiration_status = null;
      this.payment_method_selected = null;
      this.money_account_selected = null;
      this.estimated_payment_date = new Date().toISOString().slice(0, 10);
    },

    closeDialog() {
      this.$emit("closeDialog");
    },

    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
        if (this.currentStep === 2) {
          this.preparePaymentOrders();
        }
      }
    },

    previousStep() {      
      if (this.currentStep > 1) {
        this.cleanVariables();
        this.currentStep--;
      }
    },
    cleanVariables() {
      this.paymentOrdersList = [];
      this.expandedOrders = [];
      this.searchComprobantes = "";
      this.loading = false;
      this.loading_create = false;
      this.envios_creados = 0;
      this.envios_no_validos = 0;
      this.supplier_selected = [];
      this.expiration_status = null;
      this.payment_method_selected = null;
      this.money_account_selected = null;
      this.error_create = false;
    },

    getFilterParams() {
      const selectedSuppliers = (this.supplier_selected || [])
        .map((supplier) => (supplier && supplier.id ? supplier.id : null))
        .filter((id) => id != null);

      return {
        supplier: selectedSuppliers.length > 0 ? selectedSuppliers : null,
        status: this.expiration_status != null ? this.expiration_status : null,
      };
    },

    filterComprobantes() {
      this.loadComprobantesPendientes();
    },

    loadSuppliers() {
      generalService.setSection(sections.SECTION_SUPPLIERS);
      generalService
        .filter()
        .then((response) => {
          this.suppliers = response.result || [];
        })
        .catch((e) => {
          console.log("suppliers.filter error", e);
        });
    },

    loadPaymentMethods() {
      generalService.setSection(sections.SECTION_PAYMENT_METHODS);
      generalService
        .filter()
        .then((response) => {
          const items = response.result || [];
          this.paymentMethods = items.filter((item) => item.id !== paymentMethod.cheque);
        })
        .catch((e) => {
          console.log("payment_methods.filter error", e);
          this.paymentMethods = [];
        });
    },

    loadMoneyAccounts() {
      generalService.setSection(sections.SECTION_MONEY_ACCOUNTS);
      generalService
        .filter()
        .then((response) => {
          this.moneyAccounts = response.result || [];
        })
        .catch((e) => {
          console.log("money_accounts.filter error", e);
          this.moneyAccounts = [];
        });
    },

    loadComprobantesPendientes() {
      this.loading = true;
      const params = this.getFilterParams();
      paymentOrderService
        .listPendingSpents(params)
        .then((response) => {
          if (response.status) {
            this.comprobantesList = response.result;
            // Re-sync selected references: update to new objects where IDs match,
            // preserve items not in the new list (from previous filters)
            const newListMap = new Map(this.comprobantesList.map((c) => [c.id, c]));
            this.selectedComprobantes = this.selectedComprobantes.map((c) =>
              newListMap.has(c.id) ? newListMap.get(c.id) : c
            );
          } else {
            this.$toast.error(
              response.msg || "Error al cargar comprobantes pendientes",
              "Error",
            );
          }
        })
        .catch((e) => {
          console.log("paymentOrderService.listPendingSpents error", e);
          this.$toast.error("Error al cargar comprobantes pendientes", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    preparePaymentOrders() {
      // Agrupar comprobantes seleccionados por proveedor
      const groupedBySupplier = {};

      this.selectedComprobantes.forEach((comprobante) => {
        const supplierId = comprobante.supplier_id;
        const supplierName = comprobante.receiver_name;

        if (!groupedBySupplier[supplierId]) {
          groupedBySupplier[supplierId] = {
            supplier_id: supplierId,
            supplier_name: supplierName,
            supplier: comprobante.supplier,
            comprobantes: [],
            total_imputar: 0,
            total_saldo: 0,
            status: 0,
            status_create: false,
            loading: false,
            msg: "",
            supplier_bank: null,
            supplier_banks: [],
          };
        }

        groupedBySupplier[supplierId].comprobantes.push(comprobante);
        groupedBySupplier[supplierId].total_imputar += parseFloat(comprobante.total_factura || 0);
        groupedBySupplier[supplierId].total_saldo += parseFloat(comprobante.saldo_pendiente || 0);
      });

      // Convertir objeto a array y ordenar por nombre de proveedor
      this.paymentOrdersList = Object.values(groupedBySupplier).sort((a, b) =>
        a.supplier_name.localeCompare(b.supplier_name),
      );

      this.loadSupplierBanksForOrders();
    },

    loadSupplierBanksForOrders() {
      this.paymentOrdersList.forEach((order) => {
        suppliersService
          .list_supplier_bank({ supplier_id: order.supplier_id })
          .then((response) => {
            if (response.status) {
              order.supplier_banks = response.result || [];
              order.supplier_bank = order.supplier_banks.find((b) => b.is_default) || order.supplier_banks[0] || null;
            }
          })
          .catch((e) => {
            console.log("list_supplier_bank error", e);
          });
      });
    },

    removePaymentOrder(item) {
      this.paymentOrdersList = this.paymentOrdersList.filter(
        (o) => o.supplier_id !== item.supplier_id,
      );
    },

    async createItem(item) {
      const itemWithDate = {
        ...item,
        estimated_payment_date: this.estimated_payment_date,
        payment_method_id: this.payment_method_selected ? this.payment_method_selected.id : null,
        money_account_id: this.money_account_selected ? this.money_account_selected.id : null,
        supplier_bank_id: item.supplier_bank ? item.supplier_bank.id : null,
      };
      return paymentOrderService.create_massive(itemWithDate);
    },


  },
};
</script>

<style scoped>
.v-stepper {
  box-shadow: none !important;
}

.dialog-card {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  flex-shrink: 0;
  border-bottom: 1px solid #e0e0e0;
}

.dialog-body {
  flex: 1;
  min-height: 450px;
  min-height: 0;
  overflow: auto;
}

.dialog-background {
  background: #f5f5f5;
}

.dialog-stepper-header {
  background: #607d8b;
  color: white;
}

.dialog-stepper {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.dialog-stepper-items {
  flex: 1 1 auto;
}

.dialog-step-content {
  padding: 0 !important;
}

.step-content-wrap {
  min-height: 100%;
  display: flex;
  justify-content: center;
}

.step-content-inner {
  width: 100%;
  max-width: 1200px;
  padding: 16px;
}

.dialog-footer {
  flex-shrink: 0;
  background: white;
}

.comprobantes-expand-table {
  background-color: #fafafa;
}

.proveedor-cell {
  max-width: 360px;
  white-space: normal;
  word-break: break-word;
}

.aligned-filter :deep(.v-input__slot) {
  min-height: 40px !important;
}
</style>
